module.exports = __webpack_public_path__ + "static/Neo Regan-95f45a1ae947e5fcd3b39366ae3758f5.png";